// Shown when the pane is opened as a plain web page in a deployed environment
// instead of from inside Outlook.
//
// This is PRESENTATION, not a security control. The control is server-side:
// /api requires an Entra token issued to an Office client application
// (requireOfficeClient in backend/src/auth/verifyEntraToken.ts), so a browser
// visitor could never get an answer out of this app even before this screen
// existed — every call came back 401. What the bare chat UI *did* do was imply
// otherwise, to anyone who typed the hostname in, including a client's security
// reviewer. This says the true thing instead.
//
// Gated on /healthz `officeOnly` (true only when running on App Service) so
// `npm run dev` still renders the real pane in a browser tab — that is how the UI
// gets reviewed, since there is no browser automation in this repo.

export function OutsideOutlook() {
  return (
    <div className="tp-gate">
      <div className="tp-gate-card">
        <div className="tp-logo" aria-hidden="true">
          B
        </div>
        <h1 className="tp-gate-title">BayMark HR Assistant</h1>
        <p className="tp-gate-body">
          This assistant runs inside Outlook, not as a website. Open Outlook, select a
          message, and choose <b>BayMark HR Assistant</b> from the message action bar.
        </p>
        <p className="tp-gate-note">
          If you expected it to be there and it isn&rsquo;t, your administrator may not have
          assigned the add-in to your mailbox yet.
        </p>
      </div>
    </div>
  );
}
